/**
 * シリアライゼーション関連の型定義
 */

// transientマーカーのプロパティ名
// 注意: IPCではSymbolが失われるため、通常のプロパティ名を使用
export const TRANSIENT_MARKER = '__transient__' as const;

/**
 * プロパティをtransientとしてマーク（rendererプロセス用）
 */
export function markAsTransient<T extends object>(obj: T, propertyNames: string[]): T {
  Object.defineProperty(obj, TRANSIENT_MARKER, {
    value: propertyNames,
    enumerable: true,  // IPCで転送されるようにenumerableをtrueに設定
    configurable: true,
    writable: true
  });
  return obj;
}

/**
 * transientマーカーをクリア（オブジェクトから削除）
 * Materialized Viewとして保存する場合など、transientマーカーを解除したい時に使用
 */
export function clearTransient<T extends object>(obj: T): T {
  if (TRANSIENT_MARKER in obj) {
    delete (obj as Record<string, unknown>)[TRANSIENT_MARKER];
  }
  return obj;
}

/**
 * transientマークされたプロパティを除外するJSON.stringify用replacer関数を作成
 * @returns JSON.stringify用replacer関数
 */
export function createTransientAwareReplacer() {
  return function replacer(this: unknown, key: string, value: unknown): unknown {
    // ルートオブジェクトの場合はそのまま返す
    if (key === '') {
      return value;
    }

    // 親オブジェクトがtransientマーカーを持っている場合
    if (this && typeof this === 'object' && TRANSIENT_MARKER in this) {
      const transientProps = (this as Record<string, unknown>)[TRANSIENT_MARKER];
      if (Array.isArray(transientProps) && transientProps.includes(key)) {
        // transientマークされたプロパティは除外
        return undefined;
      }
    }

    // transientマーカー自体も除外
    if (key === TRANSIENT_MARKER) {
      return undefined;
    }

    return value;
  };
}